const state = {
  loading: false,
  notification: {
    show: false,
    type: 'info', // 'success', 'error', 'warning', 'info'
    message: '',
    timeout: 5000,
  },
};

const mutations = {
  SET_LOADING(state, status) {
    state.loading = status;
  },
  SET_NOTIFICATION(state, notification) {
    state.notification = {
      ...state.notification,
      ...notification,
    };
  },
  CLEAR_NOTIFICATION(state) {
    state.notification = {
      show: false,
      type: 'info',
      message: '',
      timeout: 5000,
    };
  },
};

const actions = {
  showNotification({ commit }, { type = 'info', message, timeout = 5000 }) {
    commit('SET_NOTIFICATION', {
      show: true,
      type,
      message,
      timeout,
    });

    // Otomatik olarak notification'ı gizle
    setTimeout(() => {
      commit('CLEAR_NOTIFICATION');
    }, timeout);
  },
  hideNotification({ commit }) {
    commit('CLEAR_NOTIFICATION');
  },
};

const getters = {
  loading: (state) => state.loading,
  notification: (state) => state.notification,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
